module["exports"] = [
  "BV",
  "V.O.F.",
  "Group",
  "en Zonen"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/company/suffix.js
// module id = 2552
// module chunks = 2